import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccessDirective } from './access.directive';
import { InputDirective } from './input.directive';
import { SafePipe } from './safe.pipe';
import { HioDatePipe } from './hioDate.pipe';
import { DeleteClickDirective } from './delete-click.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogDeleteComponent } from './delete.dialog.component';
import { DialogInfoComponent } from './info.dialog.component';
import { HioSecToTimePipe } from './hioSecToTime.pipe';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        DeleteClickDirective,
        SafePipe,
        AccessDirective,
        InputDirective,
        HioDatePipe,
        HioSecToTimePipe,
        DialogDeleteComponent,
        DialogInfoComponent,

    ],
    exports: [
        CommonModule,
        SafePipe,
        HioDatePipe,
        HioSecToTimePipe,
        AccessDirective,
        InputDirective,
        DeleteClickDirective,
        MatDialogModule,
        DialogInfoComponent,
        DialogDeleteComponent
    ],
    providers: [
        DatePipe,
    ]
})
export class HioShareBasicModule { }


